import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";

declare const window: any;

export default function TownplanningContainer({
  data,
  location,
  setisMapRenderVIAS,
  setIsMapFoto360POIS,
  setIsSelectedPOI,
  setIsSelectedVIA,
  isPortrait,
  menuSelected,
  setGaleriaSelected,
  setSubMenuSelected,
  subMenuSelected,
  setMenuSelected,
  theme,
  isSelected,
  setIsSelected,
  icono,
  colors,
  setFrame,
  isSideBar,
  setIsSideBar,
  setHotspotsSelected,
  version
}: any) {

  return (
    <div className={`townplanning-container`}>
      <SideBarContainer
        data={data}
        location={location}
        isPortrait={isPortrait}
        setGaleriaSelected={setGaleriaSelected}
        setSubMenuSelected={setSubMenuSelected}
        subMenuSelected={subMenuSelected}
        setMenuSelected={setMenuSelected}
        setisMapRenderVIAS={setisMapRenderVIAS}
        setIsMapFoto360POIS={setIsMapFoto360POIS}
        setIsSelectedPOI={setIsSelectedPOI}
        setIsSelectedVIA={setIsSelectedVIA} 
        theme={theme}
        isSideBar={isSideBar}
        setIsSideBar={setIsSideBar}
        menuSelected={menuSelected}
        icono={icono}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        colors={colors}
        setFrame={setFrame}
        setHotspotsSelected={setHotspotsSelected}
        version={version}
      />
    </div>
  );
}
